import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useRef, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import star_image from "../../assets/images/star-white.svg";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import styles from "../InvestWithUs/InvestWithUs.module.css";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Constants, {
  EMAIL_PLACEHOLDER,
  ENTER_VALID_CONTACT_NUMBER,
  ENTER_VALID_EMAIL,
  ENTER_VALID_NAME,
  ENTER_VALID_OTP,
  OTP_SENT_SUCCESSFULLY,
  TOAST_COMMON_API_ERROR,
  TOAST_COMMON_ERROR,
  TOAST_COMMON_OTP_SUCCESS,
  TOAST_COMMON_SUCCESS,
  encryptDecryptKey,
} from "../../constants/Constants";
import formName from "../../assets/images/form-name.svg";
import formOtp from "../../assets/images/form-otp.svg";
import formMail from "../../assets/images/form-mail.svg";
import formContact from "../../assets/images/form-contact.svg";
import formNameChange from "../../assets/images/form-name-golden.svg";
import formMailChange from "../../assets/images/form-mail-golden.svg";
import formContactChange from "../../assets/images/form-contact-golden.svg";
import formOtpChange from "../../assets/images/form-otp-golden.svg";
import location from "../../assets/images/form-state-gray.svg";
import sortObject from "../../utils/sortingObject";
import card_arrow from "../../assets/images/card-arrow-gold.svg";
import {
  InputLabel,
  TextField,
  MenuItem,
  FormControl,
  Select,
  Box,
  useMediaQuery,
} from "@material-ui/core";
import getInvestWithUsDetails from "../../services/request/investWithUs";
import Slider from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "../../commomComponents/mail1.css";

import { validateOTP, sendEnteredOTP } from "../../services/request/otp";

import { sender } from "../../utils/sendMail";

import { getEmailTemplate } from "../../utils/getEmailTemplate";

import {
  decrypt,
  encrypt,
  generateSecreteKey,
  createRequestIds,
} from "../../services/encryptionDecryptionService";
import setInvestWithUsDetails from "../../services/setRequest/setInvestWithUsDetails";
import Timer from "../../commomComponents/OtpTimer";
import InvestBanner from "../../assets/images/invest-with-us-banner.jpg";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../commomComponents/Loader";
import Mail from "../../commomComponents/mail";
import toast from "react-hot-toast";
import { hashWithSHA256, isEmailValid } from "../../utils/commonFunctions";
import SeoHelmet from "../../commomComponents/seoHelmet";

const useStyles = makeStyles({
  root: {
    width: "30%",
    marginLeft: 25,
    height: "100%",
  },
  title: {
    fontSize: 26,
    fontWeight: "bold",
    display: "flex",
  },
  pos: {
    marginBottom: 12,
  },
});
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 1345, min: 1024 },
    items: 2,
  },
  desk: {
    breakpoint: { max: 3000, min: 1345 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const InvestWithUs = () => {
  // const classes = useStyles();

  const [banner, setBanner] = useState({
    Banner: "",
    Banner_Text: "",
    Banner_Title: "",
  });

  // CustomDots
  const CustomDots = ({ onMove, index, onClick, active }) => {
    return (
      <div className={styles.list}>
        <li
          className={active ? styles.active : styles.inactive}
          onClick={() => onClick()}
        ></li>
      </div>
    );
  };

  const [offerings, setOfferings] = useState([]);
  const [belief, setBelief] = useState([]);
  const [fullname, setFullName] = React.useState("");
  const [nameErrorMsg, setNameErrorMsg] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(false);
  const [changeMail, setChanEemail] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [state, setState] = React.useState("");
  const [emailErrorMsg, setEmailErrorMsg] = React.useState(false);
  const [changeContact, setChangeContact] = React.useState(false);
  const [isActive, setIsActive] = useState(false);
  const [countryCode, setCountryCode] = React.useState(false);
  const [contactNumber, setContactNumber] = React.useState("");
  const [numberErrorMsg, setNumberErrorMsg] = React.useState(false);

  const [stateName, setStateName] = React.useState("");
  const [stateNameErrorMsg, setStateNameErrorMsg] = React.useState(false);

  const [otp1, setOtp1] = React.useState("");
  const [otp2, setOtp2] = React.useState("");
  const [otp3, setOtp3] = React.useState("");
  const [otp4, setOtp4] = React.useState("");
  const [otp5, setOtp5] = React.useState("");
  const [otp6, setOtp6] = React.useState("");
  const [otp, setOtp] = React.useState("");
  const [changeOtp, setChangeOtp] = React.useState(false);
  const [dataLabel, setDataLabel] = React.useState(false);
  const [otpClass, setOtpClass] = React.useState(false);
  const [otpErrorMsg, setOtpErrorMsg] = React.useState(false);
  //const [responseData, setResponseData] = React.useState([]);
  const [inquiry, setInquiry] = React.useState("");
  const [changeImage, setChangeImage] = React.useState(false);

  const [otpData, setOtpData] = React.useState({});
  const [otpSent, setOtpSent] = React.useState(false);
  const [otpBtnText, setOtpBtnText] = React.useState("Send OTP");

  const [otpVerified, setOtpVerified] = React.useState(false);
  const [mobVerified, setMobVerified] = React.useState(false);
  const [apiError, setApiError] = useState(false);
  const [requestId, setRequestId] = React.useState(0);
  const [requestIDs, setRequestIds] = React.useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedEmail, setIsFocusedEmail] = useState(false);
  const [isFocusedContact, setIsFocusedContact] = useState(false);
  const [isFocusedPan, setIsFocusedPan] = useState(false);
  const [isFocusedClient, setIsFocusedClient] = useState(false);
  const [isFocusedmsg, setIsFocusedmsg] = useState(false);
  const [loader, setLoader] = useState(false);
  const [customMessage, setCustomMessage] = useState(null);
  const [isautoFocus, setIsautoFocus] = useState(false);
  let otpStatus = "";
  const [chkOtp, setChkOtp] = useState("");

  console.log(isautoFocus, "autofocus");

  // const states = [{
  //   name: "Kerala",
  //   key: "kerala"
  // }, {
  //   name: "Tamil Nadu",
  //   key: "tamilnadu"
  // }, {
  //   name: "Karnataka",
  //   key: "karnataka"
  // }];
  const otpInput1Ref = useRef(null);
  const states = [
    {
      name: "Jharkhand",
      key: "jharkhand",
    },
    {
      name: "Dadra Haveli",
      key: "dadra_haveli",
    },
    {
      name: "Pondicherry",
      key: "pondicherry",
    },
    {
      name: "Delhi",
      key: "delhi",
    },
    {
      name: "Maharashtra",
      key: "maharashtra",
    },
    {
      name: "Andaman Islands",
      key: "andaman_islands",
    },
    {
      name: "Punjab",
      key: "punjab",
    },
    {
      name: "Tamil Nadu",
      key: "tamil_nadu",
    },
    {
      name: "Bihar",
      key: "bihar",
    },
    {
      name: "Assam",
      key: "assam",
    },
    {
      name: "Uttar Pradesh",
      key: "uttar_pradesh",
    },
    {
      name: "Telangana",
      key: "telangana",
    },
    {
      name: "Manipur",
      key: "manipur",
    },
    {
      name: "Tripura",
      key: "tripura",
    },
    {
      name: "Odisha",
      key: "odisha",
    },
    {
      name: "Andhra Pradesh",
      key: "andhra_pradesh",
    },
    {
      name: "Lakshadweep",
      key: "lakshadweep",
    },
    {
      name: "Himachal Pradesh",
      key: "himachal_pradesh",
    },
    {
      name: "West Bengal",
      key: "west_bengal",
    },
    {
      name: "Arunachal Pradesh",
      key: "arunachal_pradesh",
    },
    {
      name: "Uttarakhand",
      key: "uttarakhand",
    },
    {
      name: "Karnataka",
      key: "karnataka",
    },
    {
      name: "Jammu",
      key: "jammu",
    },
    {
      name: "Kerala",
      key: "kerala",
    },
    {
      name: "Madhya Pradesh",
      key: "madhya_pradesh",
    },
    {
      name: "Gujarat",
      key: "gujarat",
    },
    {
      name: "Haryana",
      key: "Haryana",
    },
    {
      name: "Mizoram",
      key: "mizoram",
    },
    {
      name: "Nagaland",
      key: "nagaland",
    },
    {
      name: "Chhattisgarh",
      key: "chhattisgarh",
    },
    {
      name: "Daman",
      key: "daman",
    },
    {
      name: "Goa",
      key: "goa",
    },
    {
      name: "Meghalaya",
      key: "meghalaya",
    },
    {
      name: "Chandigarh",
      key: "chandigarh",
    },
    {
      name: "Rajasthan",
      key: "rajasthan",
    },
  ];

  const handleChange = (event) => {
    setInquiry(event.target.value);
  };

  function setOtpSentToFalse() {
    setOtpSent(false);
    setOtpBtnText("Resend OTP");
  }

  async function sendOTP() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "callbackOTP_generate",
      inquiryType: "",
      buttonName: "Send OTP",
      email: "", // Encrypted email of the User using SHA-256 encryption
      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
      clientID: "",
      queryMessage: "",
      state: "",
      pageSection: "Request a Call Back",
      Category: "",
      FAQ: "",
    });
    if (contactNumber.length < 10) {
      handleSubmit();
      return;
    }
    setOtpSent(true);
    otpInput1Ref.current.focus();
    if (!contactNumber) {
      return;
    }
    const regexExp = /^[6-9]\d{9}$/gi;

    if (!regexExp.test(contactNumber)) {
      return;
    }
    setDataLabel(true);
    let secret = generateSecreteKey(5);
    let reqId = createRequestIds(requestId, secret);
    let reqIds = requestIDs;
    reqIds.push(reqId);
    setRequestIds(reqIds);

    let payload = {
      mobileNo: contactNumber,
      //"otp":otp,
      // txnId: reqId.requestId,
    };

    let encrypted = encrypt(payload, secret);

    let response = await sendEnteredOTP(JSON.stringify(encrypted));
    console.log("Response: ", response);

    var ENCRYPTED_KEY = changeRequestId(response.data.part2);
    // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
    let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
    console.log("decryptedData: ", decryptedData);
    if (decryptedData.statusCode === 429) {
      toast.error(decryptedData.message);
      setOtpSent(false);
      return;
    }
    if ((decryptedData.status = "success")) {
      toast.success(OTP_SENT_SUCCESSFULLY);
    } else {
      toast.error(TOAST_COMMON_API_ERROR);
    }
    console.log("SEND_OTP_RES", decryptedData);
    setOtpData(decryptedData);
    setOtpSent(true);
  }

  function setOtpSentToFalse() {
    setOtpSent(false);
    setOtpBtnText("Resend OTP");
  }

  const validateEnteredOTP = async (num) => {
    // setCustomMessage("Verifying OTP");
    otpStatus = "Verifying OTP";
    if (num.length === 6) {
      setOtp(num);
      let secret = generateSecreteKey(5);
      let reqId = createRequestIds(requestId, secret);
      let reqIds = requestIDs;
      reqIds.push(reqId);
      setRequestIds(reqIds);

      let payload = {
        mobileNo: contactNumber,
        otp: parseInt(num),
        // txnId: reqId.requestId,
      };
      console.error(payload);
      let encrypted = encrypt(payload, secret);

      let response = await validateOTP(JSON.stringify(encrypted));
      console.log("validateOTP res: ", response);
      var ENCRYPTED_KEY = changeRequestId(response.data.part2);
      // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
      let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
      console.log(decryptedData);
      if (decryptedData.status == "success") {
        // setCustomMessage("OTP verified");
        otpStatus = "OTP verified";
        setOtpVerified(true);
        setMobVerified(true);
        setOtpData({});
        toast.success(TOAST_COMMON_OTP_SUCCESS);
      } else {
        // setCustomMessage("Something went wrong");
        otpStatus = "OTP verification failed";
        setOtpVerified(false);
        setMobVerified(false);
        toast.error(decryptedData.message);
      }
    } else {
      setOtpErrorMsg(true);
    }
  };

  function changeRequestId(txnId) {
    var secret = "";
    console.warn(JSON.stringify(requestIDs));
    var latest = requestIDs.filter(function (val) {
      if (val.requestId === txnId) {
        secret = val.secret.substring(
          0,
          val.secret.length - val.requestId.length
        );
        return false;
      }
      return true;
    });
    setRequestIds(latest);
    return secret;
  }

  const handleOTPfocus = async (e) => {
    //document.querySelector('input[id="otp2"]').focus()
    if (e.target.dataset["prev"] === "otp5") {
      let _otp =
        "" +
        window.document.getElementById("otp1").value +
        window.document.getElementById("otp2").value +
        window.document.getElementById("otp3").value +
        window.document.getElementById("otp4").value +
        window.document.getElementById("otp5").value +
        window.document.getElementById("otp6").value;
      if (chkOtp !== _otp && _otp.length === 6) {
        setChkOtp(_otp);
        await validateEnteredOTP(_otp);
      }
    }
    if (
      (e.key === "Delete" || e.key === "Backspace") &&
      e.target.dataset["prev"]
    ) {
      setCustomMessage("");
      document
        .querySelector('input[id="' + e.target.dataset["prev"] + '"]')
        .focus();
    } else if (e.target.dataset["next"]) {
      setCustomMessage("");
      document
        .querySelector('input[id="' + e.target.dataset["next"] + '"]')
        .focus();
    }
  };

  function handleImageChangeFormName() {
    setChangeImage(true);
  }
  function handleChangeImageFormName() {
    setChangeImage(false);
  }
  function handleImageChangeFormMail() {
    setChanEemail(true);
  }
  function handleChangeImageFormMail() {
    setChanEemail(false);
  }
  function handleImageChangeFormContact() {
    setChangeContact(true);
  }
  function handleChangeImageFormContact() {
    setChangeContact(false);
  }
  function handleImageChangeFormOtp() {
    setChangeOtp(true);
  }
  function handleChangeImageFormOtp() {
    setChangeOtp(false);
  }

  function handleChangeName(event) {
    let alphabets =
      /^[\u00C0-\u017Fa-zA-Z'’‘’][\u00C0-\u017Fa-zA-Z’‘’' ' ']+[\u00C0-\u017Fa-zA-Z'’‘’]?$/;
    let name = event.target.value;
    setFullName(name);
    if (name.match(alphabets)) {
      setNameErrorMsg(false);
    } else if (name.match(/^[A-Z]*$/)) {
      setNameErrorMsg(false);
    } else {
      setNameErrorMsg(true);
    }
  }
  function handleEmailChange(event) {
    let email = event.target.value;
    setEmail(email);
  }

  function handleChangeStateName(event) {
    let stateName = event.target.value;
    setStateName(stateName);
    setNameErrorMsg(false);
  }
  function handleTextChange(text) {
    let num = /^-?\d*$/.test(text);
    if (num) {
      setIsActive(true);
      // setCountryCode(true);
      setContactNumber(text);
      setNumberErrorMsg(false);
    } else {
      setNumberErrorMsg(true);
    }
  }

  function handleChangeOtp1(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp1(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp2(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp2(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp3(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp3(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp4(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp4(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp5(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp5(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp6(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp6(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }

  function handleInput() {
    // setDataLabel(!dataLabel);
    setOtpClass(true);
  }

  async function handleSubmit() {
    console.log("CLICKED");
    //datalayer
    const hashedEmail = await hashWithSHA256(email);
    const hashedMobile = await hashWithSHA256(contactNumber);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "requestCallback_submit",
      inquiryType: "",
      buttonName: "SUBMIT",
      email: hashedEmail, // Encrypted email of the User using SHA-256 encryption
      contactNumber: hashedMobile, // Encrypted contact Number of the User using SHA-256 encryption
      clientID: "",
      queryMessage: "",
      state: state,
      pageSection: "Request a Call Back",
      Category: "",
      FAQ: "",
    });

    if (fullname === "") {
      setErrorMsg(true);
      setNameErrorMsg(true);
    } else {
      setErrorMsg(false);
    }
    if (email === "") {
      setEmailErrorMsg(true);
    } else if (email !== "") {
      if (isEmailValid(email)) {
        setEmailErrorMsg(false);
      } else {
        setEmailErrorMsg(true);
      }
    }
    if (contactNumber === "") {
      setNumberErrorMsg(true);
    } else {
      setNumberErrorMsg(false);
    }
    if (
      otp1 === "" ||
      otp2 === "" ||
      otp3 === "" ||
      otp4 === "" ||
      otp5 === "" ||
      otp6 === ""
    ) {
      setOtpErrorMsg(true);
    } else {
      setOtpErrorMsg(false);
    }

    if (!fullname || !email || !contactNumber || !mobVerified) {
      //!errorMsg || !otpErrorMsg || !nameErrorMsg || !emailErrorMsg || !numberErrorMsg
      return;
    } else {
      console.log("ELSE");
      let secret = generateSecreteKey(5);
      let reqId = createRequestIds(requestId, secret);
      let reqIds = requestIDs;
      reqIds.push(reqId);
      setRequestIds(reqIds);

      let payload = {
        fullName: fullname,
        email: email,
        contactNo: contactNumber,
        state: state,
        // txnId: reqId.requestId,
      };

      let encrypted = encrypt(payload, secret);

      let response = await setInvestWithUsDetails(JSON.stringify(encrypted));
      console.log("Response: ", response);
      var ENCRYPTED_KEY = changeRequestId(response.data.part2);
      // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
      let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
      console.log("decryptedData: ", decryptedData);
      if (decryptedData.status == "success") {
        // alert("Successfully sent");
        // window.location.reload();
        toast.success(TOAST_COMMON_SUCCESS);
        setFullName("");
        setEmail("");
        setContactNumber("");
        setState("");
        setOtp("");
        setOtp1("");
        setOtp2("");
        setOtp3("");
        setOtp4("");
        setOtp5("");
        setOtp6("");
        if (!sessionStorage.getItem("reloaded")) {
          sessionStorage.setItem("reloaded", "true");
          window.location.reload();
        }
      } else {
        // alert("Something went wrong");
        toast.error(TOAST_COMMON_ERROR);
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true); // Set loader to true when data fetching starts
      try {
        const data = await getInvestWithUsDetails();
        banner["Banner"] = data.data.banner[0].image;
        banner["Banner_Text"] = data.data.banner[0].description;
        banner["Banner_Title"] = data.data.banner[0].title;
        setBanner({ ...banner });
        setOfferings(data.data.offerings);
        setBelief(data.data.beliefs);
        sessionStorage.removeItem("reloaded");
      } catch (error) {
        console.error("Error fetching data:", error);
        setApiError(true);
      } finally {
        setLoader(false);
      }
    };

    fetchData();
  }, []);

  const history = useHistory();
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Function to handle navigation and scroll to top
  const handleNavigation = (path) => {
    history.push(path);
    scrollToTop();
  };
  const isMobile = useMediaQuery("(min-width: 300px)and (max-width:600px");
  const isTablet = useMediaQuery("(min-width: 601px) and (max-width: 900px)");
  const isDesktop = useMediaQuery("(min-width: 901px) and (max-width:1399px");
  const isLarge = useMediaQuery("(min-width:1400px ) and (max-width:2000px)");

  const textFieldStyle = {
    width: isMobile
      ? "200px"
      : isTablet
      ? "400px"
      : isDesktop
      ? "180px"
      : isLarge
      ? "300px"
      : "400px",
  };
  return (
    <div className={styles.home_container}>
      {loader === true ? (
        <Loader />
      ) : (
        <>
          <SeoHelmet
            title="Investment Opportunities - ICICI Pru Alternates Wealth Management"
            description="Explore investment opportunities with ICICI Pru Alternates. Our expert strategies are designed to secure your financial future. Start investing with us today."
            url="https://www.iciciprualternates.com/invest-with-us"
          />
          <Mail />
          <div className={styles.slides}>
            <div className={styles.image} style={{ position: "relative" }}>
              {banner["Banner"] && (
                <img
                  src={IMAGE_URL + banner["Banner"] + SITE_ID}
                  alt=""
                  loading="lazy"
                />
              )}
              <div className={styles.imageContent}>
                {/* <p className={styles.banner_title_top_left}>
                  {banner["Banner_Title"]}
                </p>
                <p className={styles.top_left}>{banner["Banner_Text"]}</p> */}
              </div>
              <div className={styles.overlay}></div>
            </div>
            <div className={styles.formContainer}>
              <h5 className={styles.contactUsHeading}>Request a Call Back</h5>

              <FormControl
                variant="standard"
                sx={{ m: 1, width: "29ch" }}
                className={styles.investForm}
              >
                <div className={`mailInputWrapper ${styles.inputwrapper}`}>
                  <div
                    onMouseOver={handleImageChangeFormName}
                    onMouseLeave={handleChangeImageFormName}
                  >
                    {changeImage ? (
                      <img src={formNameChange} alt="form-name-golden" />
                    ) : (
                      <img src={formName} alt="form-name" />
                    )}
                  </div>
                  <div
                    className={`textFieldContainer ${
                      isFocused
                        ? styles.contactfullnameFieldFocus
                        : styles.contactfullnameField
                    }`}
                  >
                    <TextField
                      id="full-name"
                      label={isFocused ? "" : "Full Name"}
                      type="name"
                      autoComplete="off"
                      InputProps={{ disableUnderline: true }}
                      className={styles.contactTextfield}
                      placeholder="Arjun Kumar"
                      onChange={(e) => handleChangeName(e)}
                      value={fullname}
                      required
                      InputLabelProps={{
                        style: { fontSize: 16 },
                      }}
                      inputProps={{ maxLength: 64 }}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(true)}
                      style={textFieldStyle}
                    />
                  </div>
                </div>
                {nameErrorMsg && errorMsg ? (
                  <span className={styles.errorMsgContact}>
                    {ENTER_VALID_NAME}
                  </span>
                ) : nameErrorMsg ? (
                  <span className={styles.errorMsgContact}>
                    {ENTER_VALID_NAME}
                  </span>
                ) : errorMsg ? (
                  <span className={styles.errorMsgContact}>Required</span>
                ) : (
                  ""
                )}
                <div className={`mailInputWrapper ${styles.inputwrapper}`}>
                  <div
                    onMouseOver={handleImageChangeFormMail}
                    onMouseLeave={handleChangeImageFormMail}
                  >
                    {changeMail ? (
                      <img src={formMailChange} alt="form-mail-golden" />
                    ) : (
                      <img src={formMail} alt="form-mail" />
                    )}
                  </div>
                  <div
                    className={`textFieldContainer ${
                      isFocusedEmail
                        ? styles.contactemailFieldFocus
                        : styles.contactemailField
                    }`}
                  >
                    <TextField
                      id="email"
                      label={isFocusedEmail ? "" : "Email"}
                      autoComplete="off"
                      type="email"
                      InputProps={{ disableUnderline: true, fontSize: 5 }}
                      className={styles.contactTextfield}
                      placeholder={EMAIL_PLACEHOLDER}
                      required
                      value={email}
                      onChange={(e) => handleEmailChange(e)}
                      InputLabelProps={{
                        style: { fontSize: 16 },
                      }}
                      inputProps={{ maxLength: 70 }}
                      onFocus={() => setIsFocusedEmail(true)}
                      onBlur={() => setIsFocusedEmail(true)}
                      style={textFieldStyle}
                    />
                  </div>
                </div>
                {emailErrorMsg && errorMsg ? (
                  <div style={{ display: "flex" }}>
                    <span className={styles.errorMsgContact}>
                      {ENTER_VALID_EMAIL}
                    </span>
                  </div>
                ) : (
                  ""
                )}

                <div className={`mailInputWrapper ${styles.inputwrapper}`}>
                  <div
                    onMouseOver={handleImageChangeFormName}
                    onMouseLeave={handleChangeImageFormName}
                  >
                    {changeImage ? (
                      <img src={location} alt="form-name-golden" />
                    ) : (
                      <img src={location} alt="form-name" />
                    )}
                  </div>
                  <div
                    className={`textFieldContainer ${styles.selectStateContainer}`}
                    // style={{position:"relative"}}
                  >
                    <FormControl>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select-standard"
                        value={state}
                        onChange={(e) => {
                          setState(e.target.value);
                        }}
                        label={isFocusedmsg ? "" : "Select State"}
                        disableUnderline
                        className={{ focused: styles.selected }}
                        MenuProps={{ animated: false }}
                        // className={styles.querySelecorclass}
                        style={{ textAlign: "start" }}
                        required
                        InputLabelProps={{
                          style: { fontSize: 16 },
                        }}
                        onFocus={() => setIsFocusedmsg(true)}
                        onBlur={() => setIsFocusedmsg(true)}
                        inputProps={{ "aria-label": "Without label" }}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select State
                        </MenuItem>
                        {states
                          .slice()
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((item, key) => {
                            return (
                              <MenuItem value={item.name}>
                                {" "}
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className={`mailInputWrapper ${styles.inputwrapper}`}>
                  <div
                    onMouseOver={handleImageChangeFormContact}
                    onMouseLeave={handleChangeImageFormContact}
                  >
                    {changeContact ? (
                      <img src={formContactChange} alt="form-contact-golden" />
                    ) : (
                      <img src={formContact} alt="form-contact" />
                    )}
                  </div>
                  <div className="contactInput">
                    {isFocusedContact ? (
                      <></>
                    ) : (
                      <label>
                        Contact Number<span className="asterick">*</span>
                      </label>
                    )}
                    <div className="contactNumbercode">
                      {countryCode ? (
                        <span
                          className="countryCode"
                          style={{ fontSize: "16px" }}
                        >
                          +91-
                        </span>
                      ) : (
                        ""
                      )}{" "}
                      <input
                        type="text"
                        autocomplete="off"
                        className="contactNumber"
                        onChange={(e) => handleTextChange(e.target.value)}
                        onClick={() => setCountryCode(true)}
                        onBlur={() => {
                          if (!contactNumber) {
                            setCountryCode(false);
                          }
                          setIsFocusedContact(true);
                        }}
                        value={contactNumber}
                        maxLength={10}
                        // placeholder="9880546703"
                        onFocus={() => setIsFocusedContact(true)}
                      />
                    </div>
                  </div>
                </div>
                {numberErrorMsg && errorMsg ? (
                  <span className={styles.errorMsgContact}>
                    {ENTER_VALID_CONTACT_NUMBER}
                  </span>
                ) : numberErrorMsg ? (
                  <span className={styles.errorMsgContact}>
                    {ENTER_VALID_CONTACT_NUMBER}
                  </span>
                ) : errorMsg ? (
                  <span className={styles.errorMsgContact}>Required</span>
                ) : (
                  ""
                )}
                {/* {!otpVerified ? (
                  <span className={styles.errorMsgContact}>
                    Verify contact number
                  </span>
                ) : (
                  ""
                )} */}
                <div className={styles.sendResentContainer}>
                  {!otpSent ? (
                    <a
                      onClick={(e) => {
                        sendOTP(e);
                      }}
                      className={styles.otpwrapperSendAccount}
                    >
                      {otpBtnText}
                    </a>
                  ) : (
                    !otpVerified && (
                      <Timer data={otpData} setOtpSent={setOtpSentToFalse} />
                    )
                  )}
                </div>
                <div>
                  <div className={`mailOtpInput ${styles.otpinputWrapper}`}>
                    <div className={styles.inputwrapper1}>
                      <div
                        onMouseOver={handleImageChangeFormOtp}
                        onMouseLeave={handleChangeImageFormOtp}
                      >
                        {changeOtp ? (
                          <img src={formOtpChange} alt="form-otp-golden" />
                        ) : (
                          <img src={formOtp} alt="form-otp" />
                        )}
                      </div>
                      <div className="otpInputfieldOpenAccount">
                        <label
                          className={`${
                            dataLabel ? "Active" : "accountlabel"
                          } `}
                        >
                          Provide OTP
                        </label>

                        <div
                          className={`${
                            otpClass ? "giveBorder" : "otpContainerAccount"
                          } `}
                        >
                          <input
                            name="otp1"
                            ref={otpInput1Ref}
                            type="text"
                            id="otp1"
                            data-next="otp2"
                            data-prev="otp1"
                            autoComplete="off"
                            className="otpInput"
                            value={otp1}
                            onChange={(e) => handleChangeOtp1(e)}
                            tabIndex="1"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="otp2"
                            type="text"
                            id="otp2"
                            data-next="otp3"
                            data-prev="otp1"
                            autoComplete="off"
                            className="otpInput"
                            value={otp2}
                            onChange={(e) => handleChangeOtp2(e)}
                            tabIndex="2"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="otp3"
                            type="text"
                            id="otp3"
                            data-next="otp4"
                            data-prev="otp2"
                            autoComplete="off"
                            className="otpInput"
                            value={otp3}
                            onChange={(e) => handleChangeOtp3(e)}
                            tabIndex="3"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="otp4"
                            id="otp4"
                            data-next="otp5"
                            data-prev="otp3"
                            type="text"
                            autoComplete="off"
                            className="otpInput"
                            value={otp4}
                            onChange={(e) => handleChangeOtp4(e)}
                            tabIndex="4"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="otp5"
                            id="otp5"
                            data-next="otp6"
                            data-prev="otp4"
                            type="text"
                            autoComplete="off"
                            className="otpInput"
                            value={otp5}
                            onChange={(e) => handleChangeOtp5(e)}
                            tabIndex="5"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="otp6"
                            id="otp6"
                            data-prev="otp5"
                            type="text"
                            autoComplete="off"
                            className="otpInput"
                            value={otp6}
                            onChange={(e) => handleChangeOtp6(e)}
                            tabIndex="6"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {otpErrorMsg || errorMsg ? (
                  <div style={{ dispay: "flex" }}>
                    <span className={styles.errorMsgContactOtp}>
                      {ENTER_VALID_OTP}
                    </span>
                    {/*   <span className={styles.errorMsgContactOtp}>Required</span> */}
                  </div>
                ) : (
                  ""
                )}

                <div style={{ marginTop: "20px", color: "#c9b16d" }}>
                  {/* {otpStatus.length > 2 && <span>{otpStatus}</span>} */}
                </div>

                <div
                  className={`formSubmit ${styles.contactSubmit}`}
                  onClick={handleSubmit}
                  // style={{
                  //   cursor: otpVerified ? "pointer" : "not-allowed",
                  //   opacity: otpVerified ? 1 : 0.5,
                  // }}
                  // disabled={!otpVerified}
                >
                  SUBMIT
                </div>
              </FormControl>
            </div>
          </div>

          <div className={styles.section}>
            <div className={styles.container}>
              <p className={styles.heading}>
                {Constants.coreBelief}
                <span className={styles.spanStyle}>
                  {Constants.coreBeliefsubheading}
                </span>
              </p>
              <p className={styles.para}>{Constants.beliefText}</p>
              <div className={styles.cards}>
                {sortObject(belief, "id").map((data) => {
                  return (
                    <Card className={styles.root} variant="outlined">
                      <CardContent>
                        <div>
                          {data.icon && (
                            <img src={IMAGE_URL + data.icon + SITE_ID} alt="" />
                          )}
                        </div>
                        <div>
                          <div className={styles.cardTitle1}>{data.title}</div>
                          <div className={styles.cardText1}>
                            <div className={styles.moats}>
                              {ReactHtmlParser(data.text)}
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            </div>
          </div>
          <div className={styles.offer_section}>
            <div className={styles.container}>
              <p className={styles.heading}>Our Product Offerings</p>
              <div className={styles.card}>
                <Slider
                  swipeable={true}
                  draggable={true}
                  showDots={true}
                  responsive={responsive}
                  ssr={true} // means to render carousel on server-side.
                  keyBoardControl={true}
                  customTransition="transform 0.5s ease-in-out"
                  infinite={true}
                  transitionDuration={100}
                  containerClass="carousel-container"
                  removeArrowOnDeviceType={[
                    "tablet",
                    "mobile",
                    "superLargeDesktop",
                    "desktop",
                    "desk",
                  ]}
                  dotListClass="custom-dot-list-style"
                  itemClass="carousel-item-padding-40-px"
                  // customDot={<CustomDots />}
                  autoPlay
                  autoPlaySpeed={3000}
                >
                  {sortObject(offerings, "id").map((data) => {
                    let link = "";
                    switch (data.id) {
                      case 1:
                        link =
                          "/portfolio-management-service/contrarian-investing";
                        break;

                      case 2:
                        link =
                          "/portfolio-management-service/growth-leaders-strategy";
                        break;

                      case 3:
                        link = "/portfolio-management-service/value-strategy";
                        break;

                      case 4:
                        link =
                          "/portfolio-management-service/largecap-strategy";
                        break;

                      case 5:
                        link = "/portfolio-management-service/pipe-pms";
                        break;

                      case 6:
                        link = "/portfolio-management-service/ace-strategy";
                        break;
                    }

                    return (
                      <div className={styles.cardDesign}>
                        <Link to={link} onClick={handleNavigation}>
                          <h1 className={styles.cardTitle}>
                            <span className={styles.cardImage}>
                              <img src={star_image} alt="star-blue" />
                            </span>
                            {data.title}
                          </h1>
                          <div className={styles.cardText}>
                            {ReactHtmlParser(data.description)}
                          </div>
                          <img
                            src={card_arrow}
                            alt=""
                            style={{ float: "right" }}
                          />
                        </Link>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default InvestWithUs;
